import { GroupBase } from 'react-select';

import TextFieldSelectController from './text-field-select.controller';
import { TextFieldSelectProps } from './text-field-select.model';

const TextFieldSelect = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: TextFieldSelectProps<Option, IsMulti, Group>
) => {
  return <TextFieldSelectController {...props} />;
};

export default TextFieldSelect;
